export function productFactory($resource, MyConstant) {
    "ngInject"

    return $resource('', {}, {
        detail: {
            url: `${MyConstant.ApiUrl}ECBProduct/GetProductDetail?productId=:productId`
        },
        images: {
            url: `${MyConstant.ApiUrl}ECBProduct/GetProductImages?productId=:productId`,
            isArray: true
        },
        attributes: {
            url: `${MyConstant.ApiUrl}ECBProduct/GetProductAttribute?productId=:productId`,
            isArray: true

        },
        abstractAttributes: {
            url: `${MyConstant.ApiUrl}ECBProduct/GetProductAbstractAttributes?productId=:productId`,
            isArray: true
        }

    })
}


// WEBPACK FOOTER //
// ./src/factories/product/product.ts